import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { localizer } from 'utils/localizer';
import { CustomForm, CustomInput, CustomButton } from 'modules/form';
import { requestReset } from './ForgotPasswordActions';

//import './LoginForm.css'

class ForgotPasswordForm extends CustomForm {
    constructor(props) {
        super(props);
    }
    onSubmitHandler = () => {
        if (this.isFormValid()) {
            const form = this.serializeForm();
            console.log('NEW PASS:', form);
            requestReset(form);
        }
    };
    render() {
        return (
            <div className="forgot-password-form">
                <p>
                    {!this.props.sent &&
                        'Please enter the email address that is associated with your account. A reset password link will be sent to you.'}
                    {this.props.sent &&
                        'A reset has been sent, please check your email for the reset link.'}
                    <br />
                    <br />
                </p>
                <CustomInput
                    name="email"
                    type="email"
                    label="Email Address"
                    form={this}
                />
                <CustomButton
                    type="primary-button"
                    action={this.onSubmitHandler}
                    label="Send Reset"
                    loading={this.props.loading}
                />
            </div>
        );
    }
}

export default ForgotPasswordForm;



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/forgot-password/ForgotPasswordForm.jsx